<template>
  <div class="body" id="bj">
      <Headtow></Headtow>
      <Headfor></Headfor>
      <div >
        <div id="w-center">
        <div class="index_pub_title">
            <p class="pub_d_title">会员中心</p>
            <router-link :to="`/index`" class="pub_duo pub_duo_d">
               <i class="el-icon-house size-icon"></i> 首页>会员中心
            </router-link>
            <div class="pub_xian"></div>
        </div>
        <div class="h-20"></div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">会员中心</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label">



                    <div class="left">
                        <p class="member-mc">
                          <span>欢迎{{info.username}}</span>
                         </p>
                        <div class="member-status">{{info.sf == 1?'采购人':'选购员'}}（{{info.mobile}}）</div>
                    </div>

              </div>


              <div class="h-30"></div>
             <!-- <ul class="member-zx-ul">
                <li><router-link :to="{path:'/MemberProduct',query: {memberindex: 9}}">我的产品：{{info.product}}</router-link></li>
                <li><router-link :to="{path:'/MemberAppraise',query: {memberindex: 5}}">我的评价：{{info.productspj}}</router-link></li>
                <li><router-link :to="{path:'/Forum',query: {memberindex: 4}}">我的论坛：{{info.jobs}}</router-link></li>
                <li><router-link :to="{path:'/MemberIntegral',query: {memberindex: 10}}">我的积分：{{info.integral}}</router-link></li>
              </ul> -->
              <div class="h-30"></div>
             <!-- <ul class="member-zx-tu">
                <li><router-link :to="{path:'/MemberNews',query: {memberindex: 3}}"><img src="../../static/img/member1.jpg" alt=""></router-link></li>
                <li ><router-link :to="{path:'/MemberProduct',query: {memberindex: 9}}"><img src="../../static/img/member2.jpg" alt=""></router-link></li>
                <li ><router-link :to="{path:'/Jobs',query: {index: 5}}"><img src="../../static/img/member3.jpg" alt=""></router-link></li>
              </ul> -->
              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>
          </div>

          <div class="clear"></div>

        </div>
      </div>
       <Foot></Foot>
  </div>

</template>
<style>
  .member-tis .el-dialog{border-radius: 14px;margin-top: 26vh !important;;}
  .member-tis .el-dialog__header{padding: 0 !important;}
  .member-tis .el-dialog__body img{width: 100% !important;margin: 0 auto;}
  .member-tis .el-dialog__body {padding: 0;}
</style>
<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import headfor from '@/components/public/headfor.vue';
import memberleft from '@/components/public/memberleft.vue'
export default{
  data(){
    return {
     activeIndex: '3',
     info:{},
     about:[],
     dialogVisible: false
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Headfor': headfor,
    'Memberleft': memberleft,

  },
  mounted () {
      this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/MemberInfo",{'userid':userid}).then(res => {
          console.log(res);
          that.info= res.data.user;

        });
    },

    handleClose(done) {

         done();
    }

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Member.vue